import { render, staticRenderFns } from "./EdgeText.vue?vue&type=template&id=52965298&"
import script from "./EdgeText.vue?vue&type=script&lang=ts&"
export * from "./EdgeText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports